import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_CHECKBOX, KENDO_NUMERICTEXTBOX } from "@progress/kendo-angular-inputs";
import { FlightEditLookups } from "../../../form/flight-edit-lookups";
import { FlightGroup } from "../../../form/flight-form-group";
import { ChangedFieldDirective } from "../../../changed-field.directive";

@Component({
    selector: "app-passengers-group",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_NUMERICTEXTBOX, KENDO_CHECKBOX],
    templateUrl: "./passengers-group.component.html",
    styleUrl: "../../../edit-fields.scss",
})
export class PassengersGroupComponent {
    readonly group = input.required<FlightGroup>();
    readonly lookups = input.required<FlightEditLookups>();
}
